import { render, staticRenderFns } from "./ContractTemplateEditor.vue?vue&type=template&id=1fa52a92"
import script from "./ContractTemplateEditor.vue?vue&type=script&lang=js"
export * from "./ContractTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports